import { useState } from 'react';

import CustomTagsInput from '../TagsInput';

function InputListInForm({ value, setFieldValue, styleClass, fieldName, placeholder }) {
  const [inputValue, setInputValue] = useState(value); // Initialize with existing skills

  const handleInputChange = (e) => {
    setInputValue(e); // Update the input field value
    setFieldValue(fieldName, e);
  };

  const handleInputBlur = () => {
    const eleList = inputValue
      .split(',')
      .map((ele) => ele.trim())
      .filter((ele) => ele); // Split, trim, and remove empty values

    setFieldValue(fieldName, eleList); // Update the form values
  };

  return (
    <CustomTagsInput
      className={styleClass}
      data-testid={fieldName}
      id={fieldName}
      name={fieldName}
      onBlur={handleInputBlur} // Process the input on blur
      onChange={handleInputChange} // Update the input value
      placeholder={placeholder}
      value={inputValue}
    />
  );
}

export default InputListInForm;
